<template>
  <div class="daka">
    <van-field type="textarea" rows="3" :border="false" v-model="record.intro" placeholder="说说打卡的感想和收获吧..." />

    <div class="photo_contrain">
      <div v-for="(item, index) in fileObjs" :key="index" class="photo">
        <img :src="item.content" @click.stop="onPreview(index)">
        <div class="close" @click="delPic(index)"><van-icon name="cross" /></div>
      </div>
      <van-uploader v-if="showUploadBtn" class="add_photo" :after-read="onRead">
        <van-icon name="photograph" />
      </van-uploader>
    </div>
    <!-- <div class="help_text after_field_border">至少1张，最多上传{{picLimit}}张图片</div> -->
    <div class="help_text after_field_border">上传一张跑步软件的截图</div>

    <div class="mt15">
      <van-field
        v-model="record.distance"
        type="number"
        clearable
        label="跑步距离"
        placeholder="请输入跑步距离"
      ><div class="right-label" slot="right-icon">公里</div></van-field>
      <time-picker v-model="record.duration" />
      <van-cell-group>
        <van-switch-cell v-model="record.is_country" title="越野模式" />
      </van-cell-group>
      <van-cell title="跑步配速" :value="pace" />
    </div>

    <bottom-btn title="打卡" @click.native="gotoAdd" />

    <!-- <div v-if="clazz.clazz_type == 1" class="help_text">
      每日最多打卡3次，还可打卡{{ 3 - dakaCheck.num }}次
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Icon, Field, CellGroup, Uploader, Toast, ImagePreview, Cell, SwitchCell } from 'vant'
import RecordType from './components/RecordType'
import BottomBtn from '@/components/BottomBtn'
import TimePicker from './components/TimePicker'
import { clazzSimpleInfo } from '@/api/clazz'
import { addRecord } from '@/api/record'
import { uploadImageToOss } from '@/api/upload'
import { getUploadParams } from '@/utils/upload'
import { padding } from '@/utils/index'

export default {
  name: 'Daka',
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Uploader.name]: Uploader,
    [SwitchCell.name]: SwitchCell,
    RecordType,
    TimePicker,
    BottomBtn
  },
  computed: {
    ...mapGetters([
      'ossToken'
    ]),
    showUploadBtn () {
      return this.images.length < this.picLimit
    },
    pace () {
      let distance = parseFloat(this.record.distance)
      let duration = parseFloat(this.record.duration / 60)
      distance = isNaN(distance) ? 0 : distance
      duration = isNaN(duration) ? 0 : duration

      if (distance <= 0 || duration <= 0) {
        return ''
      }

      const pace = duration / distance
      let minutes = (Math.floor(pace))
      let seconds = Math.floor((pace - minutes) * 60)
      seconds = padding(seconds + '', 2)
      return `${minutes}:${seconds} 分钟/公里`
    }
  },
  data () {
    return {
      clazzId: '',
      clazz: null,
      dakaCheck: {
        in_clazz: false,
        is_leader: false,
        status: 99,
        msg: ''
      },
      record: {
        clazz_id: null,
        is_country: false,
        intro: '',
        pictures: [],
        distance: '',
        duration: 0 // 单位秒
      },
      picLimit: 1,
      fileObjs: [],
      images: []
    }
  },
  created () {
    let clazzId = this.$route.query.clazz_id || null
    this.clazzId = clazzId
    this.record.clazz_id = clazzId
    if (clazzId) {
      this.getClazzInfo(clazzId)
    }
  },
  methods: {
    async getClazzInfo (clazzId) {
      let response = await clazzSimpleInfo(clazzId)
      this.clazz = response.data
    },
    onRead (file) {
      this.fileObjs.push(file)
      this.images.push(file.content)
    },
    delPic (index) {
      this.fileObjs.splice(index, 1)
      this.images.splice(index, 1)
    },
    onPreview (index) {
      ImagePreview({
        images: this.images,
        startPosition: index
      })
    },
    validRun () {
      if (!this.record.distance) {
        Toast('请输入跑步距离')
        return false
      }
      if (isNaN(parseFloat(this.record.distance))) {
        Toast('请输入正确的跑步距离')
        return false
      }

      const distanceTemp = this.record.distance.toString().split(".")
      const afterPointLen = distanceTemp.length > 1 ? distanceTemp[1].length : 0
      if (afterPointLen > 2) {
        Toast('跑步距离只支持两位小数')
        return false
      }

      if (!this.record.duration) {
        Toast('请输入跑步用时')
        return false
      }
      return true
    },
    async gotoAdd () {
      const recordData = Object.assign({}, this.record)
      // if (this.dakaCheck.status !== 0) {
      //   return false
      // }
      // if (!this.record.intro) {
      //   Toast('请输入打卡内容')
      //   return false
      // }
      if (!this.fileObjs.length) {
        Toast('请至少上传一张图片')
        return false
      }
      if (!this.validRun()) {
        return false;
      }

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      await this.uploadPics()
      recordData.pictures = JSON.stringify(this.record.pictures)
      const response = await addRecord(recordData)
      Toast.clear()

      const record = response.data
      this.$router.push(`/daka/poster?record_id=${record.uuid}`)
    },
    async uploadPics () {
      if (!this.fileObjs.length) {
        return false
      }

      await this.$store.dispatch('GetOssToken', 'record_image')

      let pictures = []
      for (let index = 0; index < this.fileObjs.length; index++) {
        const fileObj = this.fileObjs[index]
        const formData = getUploadParams(this.ossToken, fileObj.file)

        await uploadImageToOss(this.ossToken.host, formData)
        pictures.push(formData.get('key'))
      }

      this.record.pictures = pictures
    }
  }
}
</script>

<style scoped lang="scss">
.photo_contrain {
  padding-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  .photo {
    width: 150px;
    height: 150px;
    margin-left: 30px;
    margin-top: 20px;
    position: relative;
    box-sizing: border-box;
    img {
      width: 150px;
      height: 150px;
      object-fit: cover;
    }
    .close {
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
      font-size: 28px;
      width: 40px;
      height: 40px;
      border-bottom-left-radius: 6px;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .add_photo {
    width: 150px;
    height: 150px;
    margin-left: 30px;
    margin-top: 20px;
    box-sizing: border-box;
    border: 1PX solid #ebedf0;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.help_text {
  color: rgba(69,90,100,.6);
  padding: 15px 30px 15px;
  font-size: 28px;
}
.right-label {
  width: 80px;
  &.heart {
    width: 120px;
  }
}
</style>
